var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "15px",
    viewBox: "0 0 31 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72688688-5D7C-432D-947B-7B9E13995ACD@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Changes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Class-Summary",
    transform: "translate(-438.000000, -435.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(237.000000, 391.795978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(164.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(37.807547, 26.030741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6087483,12.796482 C19.0439197,12.796482 23.479091,12.796482 27.9143212,12.796482 C28.4030642,12.796482 28.4035636,12.7961364 28.4035636,12.4572879 C28.4035636,8.70151111 28.4035636,4.94577621 28.4035636,1.18999941 C28.4035636,0.853622425 28.4030642,0.8530988 27.9412875,0.8530988 C19.0513222,0.8530988 10.1613568,0.8530988 1.27139148,0.8530988 C0.812376032,0.8530988 0.811530389,0.853622425 0.811530389,1.17077188 C0.811530389,4.94049806 0.811530389,8.71022424 0.811530389,12.4799504 C0.811530389,12.795927 0.812434782,12.796482 1.27380024,12.796482 C5.71878291,12.796482 10.1637656,12.796482 14.6087483,12.796482 M0,0.00336883103 C0.0950061162,0.00224934257 0.189955172,0 0.284961288,0 C9.83333274,0 19.3817613,0 28.9301898,0 C29.0251388,0 29.1201449,0.00224934257 29.215094,0.00336883103 L29.215094,13.6445431 C29.1011437,13.6462431 28.9871934,13.6493942 28.8732432,13.6493942 C19.3628171,13.6495808 9.85233397,13.6495808 0.341850836,13.6493942 C0.227900557,13.6493942 0.113950279,13.6462431 0,13.6445431 C0,9.09747119 0,4.55044074 0,0.00336883103",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.86918233,
    cy: 6.8247904,
    rx: 1.62306078,
    ry: 1.7061976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6950773,9.98048113 L12.6950773,8.92290797 L10.0387748,8.92290797 L10.0387748,3.4123952 L8.92683428,3.4123952 L8.92683428,9.98048113 L12.6950773,9.98048113 Z M14.5924361,9.98048113 L14.5924361,3.4123952 L13.4804956,3.4123952 L13.4804956,9.98048113 L14.5924361,9.98048113 Z M18.6519017,9.98048113 L21.1758302,3.4123952 L19.9756404,3.4123952 L18.2194803,8.37556748 L16.5162698,3.4123952 L15.2366557,3.4123952 L17.6899848,9.98048113 L18.6519017,9.98048113 Z M26.144263,9.98048113 L26.144263,8.92290797 L22.9584651,8.92290797 L22.9584651,7.14173213 L25.8265657,7.14173213 L25.8265657,6.08415897 L22.9584651,6.08415897 L22.9584651,4.46996836 L25.9854144,4.46996836 L25.9854144,3.4123952 L21.8465245,3.4123952 L21.8465245,9.98048113 L26.144263,9.98048113 Z",
    id: "LIVE",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.3db324faa1fc5ae2532f20ce1e32c674.svg";
export { ForwardRef as ReactComponent };